<div class="radio-group">
    @for (rangeItem of rangeItems; track $index) {
    <div class="radio-option">
        <input
            type="radio"
            [id]="'ai-scale-' + rangeItem.value"
            name="ai-scale"
            [value]="rangeItem.scaleLevel"
            [checked]="value === rangeItem.scaleLevel"
            (change)="selectValue(rangeItem.scaleLevel)"
        />
        <label [for]="'ai-scale-' + rangeItem.value" class="radio-label">
            <span class="label-value">{{ rangeItem.value }}</span>
            <span class="label-text">{{ rangeItem.label }}</span>
        </label>
    </div>
    }
</div>
